<template>
  <div style="display: flex; gap: 40px; padding: 20px;">
    <div>
      <h3>Liste 1 (fixe, remplace sur drop uniquement)</h3>
      <ul id="list1" class="list-group">
        <li v-for="(item, index) in list1" :key="item.id" class="list-item">
          {{ item.name }} ({{ index }})
        </li>
      </ul>
    </div>

    <div>
      <h3>Liste 2 (source clone)</h3>
      <ul id="list2" class="list-group">
        <li v-for="item in list2" :key="item.id" class="list-item">
          {{ item.name }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Sortable from 'sortablejs'

const list1 = ref([
  { id: 1, name: 'Alice' },
  { id: 2, name: 'Bob' },
  { id: 3, name: 'Charlie' },
])

const list2 = ref([
  { id: 101, name: 'Xavier' },
  { id: 102, name: 'Yasmine' },
  { id: 103, name: 'Zoe' },
])

onMounted(() => {
  Sortable.create(document.getElementById('list1'), {
    group: {
      name: 'people',
      pull: false,
      put: true,
    },
    sort: false, // interdit le tri dans list1
    animation: 150,
    forceFallback: true,
    ghostClass: 'ghost-hidden',

    onMove(evt) {
      // Bloquer la prévisualisation et empêcher insertion
      const fromList2 = evt.from.id === 'list2'
      const toList1 = evt.to.id === 'list1'

      if (fromList2 && toList1) {
        return false // bloque preview + ajout
      }
      return true
    },

    onAdd(evt) {
      // Ici on remplace au lieu d'ajouter
      const fromList2 = evt.from.id === 'list2'
      const toList1 = evt.to.id === 'list1'

      if (fromList2 && toList1) {
        const dropIndex = evt.newIndex
        const draggedName = evt.item.textContent.trim()
        const droppedObj = list2.value.find(el => el.name === draggedName)
        if (!droppedObj) return

        // Remplace l'élément à dropIndex dans list1
        list1.value.splice(dropIndex, 1, { ...droppedObj })

        // Supprime l'élément ajouté automatiquement (clone)
        evt.item.remove()
      }
    },

    onUpdate(evt) {
      // Empêcher le déplacement interne dans list1 (tri)
      // En principe sort:false suffit, mais on peut sécuriser
      evt.preventDefault()
    }
  })

  Sortable.create(document.getElementById('list2'), {
    group: {
      name: 'people',
      pull: 'clone',
      put: false,
    },
    sort: false,
    animation: 150,
    forceFallback: true,
    ghostClass: 'ghost-hidden',
  })
})
</script>

<style scoped>
.list-group {
  width: 200px;
  min-height: 150px;
  border: 2px dashed #666;
  padding: 10px;
  background: #fafafa;
  list-style: none;
}

.list-item {
  padding: 8px;
  margin-bottom: 6px;
  background: #fff;
  border: 1px solid #ddd;
  cursor: grab;
  user-select: none;
}

.ghost-hidden {
  display: none !important;
}
</style>
